import { format, isValid, parseISO } from 'date-fns';
import { ptBR } from 'date-fns/locale';

/**
 * Formata uma data de forma segura, evitando o erro "Invalid time value".
 * @param dateStr String da data ou objeto Date
 * @param formatStr Formato desejado (ex: 'dd/MM/yyyy')
 * @returns Data formatada ou um fallback (padrão: '-')
 */
export function safeFormat(
    dateStr: string | Date | null | undefined,
    formatStr: string = 'dd/MM/yyyy',
    fallback: string = '-'
): string {
    if (!dateStr) return fallback;

    const date = typeof dateStr === 'string' ? parseISO(dateStr) : dateStr;

    if (!isValid(date)) {
        // Tenta o construtor Date se o parseISO falhar (para formatos não ISO)
        const dateFallback = new Date(dateStr);
        if (!isValid(dateFallback)) {
            return fallback;
        }
        return format(dateFallback, formatStr, { locale: ptBR });
    }

    return format(date, formatStr, { locale: ptBR });
}

/**
 * Verifica se uma data já passou.
 */
export function isPastDate(dateStr: string | Date | null | undefined): boolean {
    if (!dateStr) return false;
    const date = typeof dateStr === 'string' ? parseISO(dateStr) : dateStr;
    if (!isValid(date)) {
        const dateFallback = new Date(dateStr as any);
        if (!isValid(dateFallback)) return false;
        return dateFallback.getTime() < new Date().setHours(0, 0, 0, 0);
    }
    
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    
    const targetDate = new Date(date);
    targetDate.setHours(0, 0, 0, 0);
    
    return targetDate.getTime() < today.getTime();
}
